const dummyNews = [
    { title: "Plastic price surge expected" },
    { title: "Polymer demand rising in India" },
    { title: "Recycling sector booming" }
];

const NewsSlider = () => {

    return (
        <div className="card news-slider">

            <div className="news-header">
                <h3>News & Blogs</h3>
                <button>View All</button>
            </div>

            <div className="news-items">

                {dummyNews.map((n, i) => (
                    <div key={i} className="news-card">
                        {n.title}
                    </div>
                ))}

            </div>

        </div>
    );
};

export default NewsSlider;